import { render } from "./ViewTrainees.vue?vue&type=template&id=4659ca2a&scoped=true"
import script from "./ViewTrainees.vue?vue&type=script&lang=js"
export * from "./ViewTrainees.vue?vue&type=script&lang=js"

import "./ViewTrainees.vue?vue&type=style&index=0&id=4659ca2a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4659ca2a"]])

export default __exports__